var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right"},[_c('div',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.generate}},[_c('i',{staticClass:"fa fa-download",attrs:{"title":"Download Excel"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfed96da","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download.vue
// module id = 1796
// module chunks = 27